import React, { useState } from 'react';
import { Calendar as CalendarUI } from './ui/calendar';
import { Card } from './ui/card';
import { useLanguage } from '../contexts/LanguageContext';

export const AvailabilityCalendar = ({ appointments = [], onDateSelect }) => {
  const { t, language } = useLanguage();
  const [selectedDate, setSelectedDate] = useState(new Date());

  // Group appointments by date
  const appointmentsByDate = appointments.reduce((acc, apt) => {
    const date = apt.appointment_date;
    if (!acc[date]) acc[date] = [];
    acc[date].push(apt);
    return acc;
  }, {});

  const bookedDates = Object.keys(appointmentsByDate).map(d => new Date(d));

  const selectedKey = selectedDate?.toISOString().split('T')[0];
  const dayAppointments = appointmentsByDate[selectedKey] || [];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <Card className="p-4 flex justify-center" data-testid="availability-calendar">
        <CalendarUI
          mode="single"
          selected={selectedDate}
          onSelect={(d) => {
            setSelectedDate(d);
            onDateSelect?.(d);
          }}
          modifiers={{ booked: bookedDates }}
          modifiersClassNames={{ booked: 'bg-[#1e88e5] text-white hover:bg-[#1565c0]' }}
          className="rounded-md"
          dir={language === 'ar' ? 'rtl' : 'ltr'}
        />
      </Card>

      <Card className="p-4">
        <h3 className="font-bold text-lg text-[#2c3e50] mb-3">
          {selectedDate?.toLocaleDateString(language === 'ar' ? 'ar-EG' : language === 'fr' ? 'fr-FR' : 'en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
        </h3>
        {dayAppointments.length === 0 ? (
          <p className="text-gray-500 text-sm">{t('لا توجد مواعيد في هذا اليوم', 'No appointments on this day', 'Aucun rendez-vous ce jour')}</p>
        ) : (
          <div className="space-y-2 max-h-80 overflow-y-auto">
            {dayAppointments.map((apt) => (
              <div key={apt._id} className="border rounded-lg p-3 hover:bg-blue-50">
                <div className="flex justify-between items-start">
                  <div>
                    <p className="font-semibold text-sm">{apt.patient_name || apt.doctor_name}</p>
                    <p className="text-xs text-gray-500">{apt.appointment_time}</p>
                    <p className="text-xs text-gray-500">{apt.consultation_type}</p>
                  </div>
                  <span className={`px-2 py-1 rounded-full text-xs ${
                    apt.status === 'completed' ? 'bg-green-100 text-green-700' :
                    apt.status === 'pending' ? 'bg-yellow-100 text-yellow-700' :
                    'bg-gray-100 text-gray-700'
                  }`}>
                    {apt.status}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
};
